module.exports = __webpack_public_path__ + "static/media/Banner Image 1_without text-5.4b87b9f8.png";